import { infractionFields } from "../constants/fieldConstants";
import infractionNames from '../InfractionNames.json';
/**
 * Transforms the raw API response into the structure:
 * { fields: [...], rows: [...] }
 *
 * @param {Array} apiData - Array of data objects from your API.
 * @returns {Object} The transformed object.
 */
export const transformApiResponse = (apiData) => {
  // Optionally, only transform a limited number of records.
  console.log("Sujeet transformApiResponse apiData", apiData)

  const rows = apiData.map(record =>
    infractionFields.map(field => {
      let fieldName = field.name;

      let value = '';

      if (field.name === "Infraction Type") {
        fieldName = "label_class";
        value = infractionNames[record[fieldName].trim()];
        if (!value) {
            console.error("Sujeet infractionNames error[" + record[fieldName] + "]");
        }
      } else if (field.name === "Vehicle Type") {
        fieldName = "response_bodyresultclass";
        value = record[fieldName];
      } else {
        value = record[fieldName];
      }

      if (field.type === "integer") {
        return typeof value === "number" ? value : parseInt(value, 10);
      } else if (field.type === "real") {
        return typeof value === "number" ? value : parseFloat(value);
      }
      return value;
    })
  );

  return { fields: infractionFields, rows };
}